module.exports = __webpack_public_path__ + "audio/voice2.m4a";